module.exports = __webpack_public_path__ + "media/spa/flow_step_03-bec11fe3.svg";